module.exports = __webpack_public_path__ + "img/lunchly_menu5.b28eed6e.png";